import { render, staticRenderFns } from "./TinyMecEditor.vue?vue&type=template&id=bcc98f6c"
import script from "./TinyMecEditor.vue?vue&type=script&lang=js"
export * from "./TinyMecEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports